import { UAParser } from "ua-parser-js";

export default (uastring?: string) => {
  const { type } = new UAParser(uastring).getDevice();

  return type === "mobile";
};
